import React from 'react';
import type { ApiActivityFilters as ApiActivityFilterValues } from '../../../models/apiActivity';
import type { AuditCompanyOption } from './AuditFiltersPanel';

export interface ApiActivityFiltersProps {
  filters: ApiActivityFilterValues;
  companies: AuditCompanyOption[];
  onChange: (next: ApiActivityFilterValues) => void;
}

export function ApiActivityFilters({ filters, companies, onChange }: ApiActivityFiltersProps): React.ReactElement {
  return (
    <div className="bo-admin-toolbar bo-card">
      <label className="bo-field" htmlFor="api-activity-route">
        <span className="bo-field-label">Endpoint</span>
        <input
          id="api-activity-route"
          type="text"
          className="bo-input"
          placeholder="e.g. api/admin"
          value={filters.route ?? ''}
          onChange={(event) => onChange({ ...filters, route: event.target.value || undefined })}
        />
      </label>
      <label className="bo-field" htmlFor="api-activity-user">
        <span className="bo-field-label">User</span>
        <input
          id="api-activity-user"
          type="text"
          className="bo-input"
          placeholder="User id"
          value={filters.userId ?? ''}
          onChange={(event) => onChange({ ...filters, userId: event.target.value || undefined })}
        />
      </label>
      <label className="bo-field" htmlFor="api-activity-company">
        <span className="bo-field-label">Company</span>
        <select
          id="api-activity-company"
          className="bo-input"
          value={filters.companyId ?? ''}
          onChange={(event) => onChange({ ...filters, companyId: event.target.value || undefined })}
        >
          <option value="">All</option>
          {companies.map((company) => (
            <option key={company.companyId} value={company.companyId}>
              {company.companyName}
            </option>
          ))}
        </select>
      </label>
      <label className="bo-field" htmlFor="api-activity-status">
        <span className="bo-field-label">Status code</span>
        <input
          id="api-activity-status"
          type="number"
          className="bo-input"
          placeholder="e.g. 403"
          value={filters.statusCode ?? ''}
          onChange={(event) => onChange({ ...filters, statusCode: event.target.value || undefined })}
        />
      </label>
      <label className="bo-field" htmlFor="api-activity-from-date">
        <span className="bo-field-label">From</span>
        <input
          id="api-activity-from-date"
          type="date"
          className="bo-input"
          value={filters.fromDate ?? ''}
          onChange={(event) => onChange({ ...filters, fromDate: event.target.value || undefined })}
        />
      </label>
      <label className="bo-field" htmlFor="api-activity-to-date">
        <span className="bo-field-label">To</span>
        <input
          id="api-activity-to-date"
          type="date"
          className="bo-input"
          value={filters.toDate ?? ''}
          onChange={(event) => onChange({ ...filters, toDate: event.target.value || undefined })}
        />
      </label>
    </div>
  );
}
